import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../redux/store'
import { googleLogin } from '../redux/auth/actions'
import FullPageLoader from '../Components/Common/Loading/FullPageLoader'

export default function GoogleLogin() {
  const dispatch = useAppDispatch()
  const loadingMessage = useAppSelector((state) => state.auth.loadingMessage)

  useEffect(() => {
    dispatch(googleLogin())
  }, [dispatch])

  return <FullPageLoader message={loadingMessage} />
}
